import { cn } from "@/lib/utils";

// Wordmark. Coral dot mark + warm display name. Friendly and distinct from
// the generic AI logo template.
export function Brand({
  size = "md",
  className,
}: {
  size?: "sm" | "md" | "lg";
  className?: string;
}) {
  const sizes = {
    sm: { dot: "h-2 w-2", text: "text-[1.1rem]" },
    md: { dot: "h-2.5 w-2.5", text: "text-[1.35rem]" },
    lg: { dot: "h-3.5 w-3.5", text: "text-[2.4rem]" },
  }[size];

  return (
    <div className={cn("flex items-center gap-2.5", className)}>
      <span
        aria-hidden
        className={cn(
          "inline-block rounded-full bg-primary shadow-[0_0_0_4px_hsl(var(--primary-soft))]",
          sizes.dot,
        )}
      />
      <span
        className={cn(
          "font-display font-medium text-ink",
          sizes.text,
        )}
        style={{ fontVariationSettings: '"wdth" 92, "opsz" 36' }}
      >
        AI1 <span className="text-ink-muted font-normal">Assistant</span>
      </span>
    </div>
  );
}
